module.exports = __webpack_public_path__ + "img/MassGIS 2005.2c24a798.png";